import { bob as viemBob } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const bob = {
  displayName: 'BOB',
  runtime: 'evm',
  viemChain: viemBob,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'bob' },
    pimlico: { chainSlug: 'bob' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
